module.exports = __webpack_public_path__ + "img/banking-details.f93e8f7c.png";